
import { createActions, createReducer } from "reduxsauce";

const { Types, Creators } = createActions({
  requestServices: [],
  successfulServices: ["payload"],
  errorServices: ["error"],
  successfulFetchIntervalDates: ["payload"]
});

export const ServicesActionCreators = Creators;

const initialState = {
  loading: false,
  services: [],
  error: "",
  selectedService: {},
  searchText: "",
  message: "",
  intervalDates: [],
  categories: [],
};

const requestServices = (state = initialState) => ({
  ...state,
  loading: true,
  error: "",
  services: [],
});


const successfulServices = (state = initialState, action) => {
  const { message, services } = action.payload.result;
  return {
    ...state,
    loading: false,
    message,
    services
  };
};

const successfulFetchIntervalDates= (state = initialState, action) => {
  const { message, intervalDates } = action.payload.result;
  return {
    ...state,
    loading: false,
    message,
    intervalDates
  };
};

const errorServices = (state = initialState, action) => ({
  ...state,
  loading: false,
  error: action.error,
  services: null,
});


export default createReducer(initialState, {
  [Types.REQUEST_SERVICES]: requestServices,
  [Types.SUCCESSFUL_SERVICES]: successfulServices,
  [Types.ERROR_SERVICES]: errorServices,
  [Types.SUCCESSFUL_FETCH_INTERVAL_DATES]: successfulFetchIntervalDates
});